import { filePutCall } from '../../helpers/api/api'
import { setPercentage } from '../../store/actions/percentage'

async function validateInputs(refs) {
    for (let ref in refs) {
        if (await refs[ref].validateInput() === false) return false
    }
    return true
}
async function onFormSubmit(state, refs, endPoint) {
    if (await validateInputs(refs) === false) return

    const formData = new FormData();
    for (var key in state) {
        if (state.hasOwnProperty(key)) {
            if(Array.isArray(state[key])){
                formData.append(key.toString(), JSON.stringify(state[key]))
            }else{
                formData.append(key.toString(), state[key])
            }
        }
    }
    const result = await filePutCall(endPoint, formData)
    setPercentage(0)
    return Promise.resolve(result)
}

export default onFormSubmit
